import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import nutritionReducer from "./nutritionSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    nutrition: nutritionReducer,
  },
});
